import { motion } from "framer-motion";
import { Warehouse, Truck, Box, Bike } from "lucide-react";
import ServicePillars from "@/components/ServicePillars";
import DarkStoreOps from "@/components/DarkStoreOps";
import MarketplaceManagement from "@/components/MarketplaceManagement";
import QcPartners from "@/components/QcPartners";
import CtaBanner from "@/components/CtaBanner";
import Section, { SectionHeading } from "@/components/Section";

const FULFILMENT_CAPS = [
  { icon: Warehouse, title: "Regional Warehousing", desc: "Hub & spoke placement strategy" },
  { icon: Box, title: "Stock Placement", desc: "Inventory positioned closer to demand" },
  { icon: Truck, title: "Dispatch Coordination", desc: "Routing, batching, handover" },
  { icon: Bike, title: "Last-Mile Support", desc: "Rider fleet coordination" },
];

export default function Services() {
  return (
    <div data-testid="page-services" className="pt-[72px]">
      <Section id="services-intro" bg="white">
        <SectionHeading
          eyebrow="Capabilities"
          title={<>Operational depth across <span className="text-[#99CC00]">dark store, marketplace</span> and fulfilment.</>}
          sub="A single operating partner for the moving parts of quick commerce — store-floor execution, brand-side QC marketplace management and fulfilment networks."
        />
      </Section>

      <ServicePillars />
      <DarkStoreOps />

      <Section id="fulfilment-capabilities" bg="soft">
        <SectionHeading
          eyebrow="Fast Fulfilment & Warehousing"
          title={<>Built for Tier 2 & Tier 3 <span className="text-[#99CC00]">expansion.</span></>}
          sub="Regional warehousing, order fulfilment, dispatch coordination and last-mile support."
        />
        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {FULFILMENT_CAPS.map((c, i) => (
            <motion.div
              key={c.title}
              initial={{ opacity: 0, y: 14 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.4, delay: i * 0.05 }}
              className="rounded-3xl bg-white p-7 border border-neutral-200 shadow-sm hover:-translate-y-1 hover:shadow-xl hover:border-[#99CC00]/40 transition"
            >
              <div className="mb-5 inline-flex p-3 rounded-2xl" style={{ background: "rgba(153,204,0,0.14)" }}>
                <c.icon className="w-7 h-7 text-[#99CC00]" />
              </div>
              <h3 className="text-lg lg:text-xl font-display font-black text-[#1F1F1F]">{c.title}</h3>
              <p className="mt-2 text-sm text-neutral-600">{c.desc}</p>
            </motion.div>
          ))}
        </div>
      </Section>

      <MarketplaceManagement />
      <QcPartners />
      <CtaBanner title="Want a tailored operating plan for your QC expansion?" cta="Talk to OneHill" />
    </div>
  );
}
